import { PageType } from 'api/page-template/types';
import { useMemo } from 'react';
import {
  useGetDefaultAiSectionCommands,
  useGetDefaultMeetingBlockCommands,
} from './default-ai-section-commands';
import { useGetDefaultFormattingCommands } from './formatting-commands';
import { useGetTemplateSectionsCommands } from './meeting-template-sections';
import { CommandPickerItem } from '../types';

export const useDefaultCommands = ({
  pageType,
}: {
  pageType?: PageType;
}): {
  items: CommandPickerItem[];
  isLoading: boolean;
} => {
  const formattingCommands = useGetDefaultFormattingCommands();
  const aiSectionCommands = useGetDefaultAiSectionCommands();
  const meetingBlockCommands = useGetDefaultMeetingBlockCommands();
  const meetingTemplateSectionsCommands = useGetTemplateSectionsCommands({
    pageType: pageType,
  });

  return useMemo(
    () => ({
      items: [
        ...aiSectionCommands,
        ...meetingBlockCommands,
        ...meetingTemplateSectionsCommands.items,
        ...formattingCommands,
      ],
      isLoading: meetingTemplateSectionsCommands.isLoading,
    }),
    [
      aiSectionCommands,
      meetingBlockCommands,
      formattingCommands,
      meetingTemplateSectionsCommands,
    ],
  );
};
